// src/components/contact/ContactInfo.js
import React, { useEffect, useRef } from 'react';
import { slideIn } from '../../utils/gsapAnimations';

function ContactInfo({ content }) {
  const sectionRef = useRef(null);

  useEffect(() => {
    slideIn(sectionRef.current, 'right', 0.5);
  }, []);

  return (
    <div ref={sectionRef} className="bg-primary text-cream p-6 rounded-lg shadow-md mt-6">
      <h3 className="text-xl font-lora font-semibold mb-4">
        {content?.title || 'Contact Information'}
      </h3>
      <div className="space-y-2 text-poppins">
        <p><strong>Email:</strong> {content?.email || 'support@myshop.com'}</p>
        <p><strong>Phone:</strong> {content?.phone || '(123) 456-7890'}</p>
        <p><strong>Address:</strong> {content?.address || '123 Sustainable St, Eco City, NY 10001'}</p>
        {/* <p><strong>Hours:</strong> {content?.hours || 'Mon-Fri, 9 AM - 5 PM'}</p> */}
      </div>
    </div>
  );
}

export default ContactInfo;